import React, { useMemo, useState } from 'react'
import Button from '../../../atoms/button/button';
import MentoriaIconTitle from '../mentoria-icon-title/mentoriaIconTitle';
import MentoriaToast from '../mentoria-toast/mentoriaToast';
import './mentoriaAgendamientoCitas.scss'

interface MentoriaAgendamientoCitasProps {
    icons: Array<string>;
    showAgendamiento: any;
}

const CustomCheckbox = ({ displayValue, value, size = "small", onChange = () => { }, checked = false }) => {
    return (
        <div className={`custom-checkbox custom-checkbox--${size}`}>
            <input
                type='checkbox'
                className="custom-checkbox__input"
                value={value}
                onChange={onChange}
                checked={checked}
            />
            <label className="custom-checkbox__label">
                {displayValue}
            </label>
        </div>
    )
}

const MentoriaAgendamientoCitas = (props: MentoriaAgendamientoCitasProps) => {
    const [optionNumber, setOptionNumber] = useState(0);
    const [saved, setSaved] = useState(false);
    const [selectedDays, setSelectedDays] = useState<any>([]);
    const [selectedTimes, setSelectedTimes] = useState<any>([]);
    const [schedules, setSchedules] = useState<any>([]);

    const handleChangeDay = (e: any) => {
        e.persist();

        const idx = selectedDays.indexOf(e.target.value);
        if (idx >= 0) {
            const tempDays = [...selectedDays];
            tempDays.splice(idx, 1);
            setSelectedDays(tempDays);
            return;
        }

        setSelectedDays((prev) => [...prev, e.target.value])
    }

    const handleChangeTime = (e) => {
        e.persist();

        const currentTime = JSON.parse(e.target.value);
        const idx = selectedTimes.findIndex((time) => time.from === currentTime.from && time.to === currentTime.to);
        if (idx >= 0) {
            const tempTime = [...selectedTimes];
            tempTime.splice(idx, 1);
            setSelectedTimes(tempTime);
            return;
        }

        setSelectedTimes((prev) => [...prev, currentTime])
    }

    const saveTime = () => {
        if (!selectedDays.length || !selectedTimes.length) {
            alert("Debes seleccionar al menos un día y un horario");
            return;
        }
        setSaved(true);
        setTimeout(() => {
            props.showAgendamiento(false);
        }, 5000);
    }

    const days = useMemo(() => [
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
    ], []);

    const timeSpans = useMemo(() => [
        {
            displayValue: "9:00 a.m. a 11:00 a.m.",
            from: 9,
            to: 11
        },
        {
            displayValue: "11:00 a.m. a 1:00 p.m.",
            from: 11,
            to: 13
        },
        {
            displayValue: "1:00 p.m. a 3:00 p.m.",
            from: 13,
            to: 15
        },
        {
            displayValue: "3:00 p.m. a 5:00 p.m.",
            from: 15,
            to: 17
        },
        {
            displayValue: "5:00 p.m. a 7:00 p.m.",
            from: 17,
            to: 19
        },
    ], []);

    return (
        <div className="mentoria-agensdamiento-citas">
            <header className="mentoria-agendamiento-citas__header">
                <h2 className="mentoria-agendamiento-citas__header__title">¿En que momento te podemos llamar?</h2>
                <h3 className="mentoria-agendamiento-citas__header__subtitle">Opción {optionNumber + 1}</h3>
                <p className="mentoria-agendamiento-citas__header__text">Dinos cuál es el mejor día y los horarios para llamarte</p>
            </header>
            <div className="mentoria-agendamiento-citas__container">
                <section className="mentoria-agendamiento-citas__section">
                    <MentoriaIconTitle text='Elige un día' src={props.icons[0]} />
                    <div className="mentoria-agendamiento-citas__section__days" onChange={handleChangeDay}>
                        {
                            days.map(day => (
                                <CustomCheckbox value={day} displayValue={day} checked={selectedDays.includes(day)} />
                            ))
                        }
                    </div>
                </section>
                <section className="mentoria-agendamiento-citas__section">
                    <MentoriaIconTitle text='Elige los horarios' src={props.icons[1]} />
                    <div className="mentoria-agendamiento-citas__section__time" onChange={handleChangeTime}>
                        {
                            timeSpans.map(time => {
                                let isChecked = selectedTimes.findIndex((_time) => _time.from === time.from && _time.to === time.to) >= 0 ? true : false;
                                return (
                                    <CustomCheckbox
                                        value={JSON.stringify(time)}
                                        displayValue={time.displayValue}
                                        size="big"
                                        checked={isChecked}
                                    />
                                )
                            })
                        }
                    </div>
                </section>
            </div>
            <div className="mentoria-agendamiento-citas__button-container">
                <Button type='button' classname='mentoria-agendamiento-citas__button' text={'Atrás'} gtmMark='primary' isDisabled={false}
                    onClickAction={() => props.showAgendamiento(false)}
                />
                <Button type='button' classname='mentoria-agendamiento-citas__button' text={'Guardar'} gtmMark='secondary' isDisabled={false}
                    onClickAction={saveTime}
                />
            </div>
            {saved && <MentoriaToast text='Horario guardado' color='success' />}
        </div>
    )
}

export default MentoriaAgendamientoCitas;